import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import { QueryParams } from '@/core/query-params.service';
import FlagIconService from '@/core/flagicon.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageMenuItem',
  props: {
    item: null,
    selectedMode: null
  },
  setup(__props: any) {

const props = __props as {
    item: MarketViewObject,
    selectedMode: IMode
}



const countryHtml = ref<string>('');

onMounted(() => {
    const splitCode = props.item.code.toLowerCase().split('-');
    const country = splitCode.length > 1 ? splitCode[1] : '';
    countryHtml.value = FlagIconService.getFlagHtml(country);
});

function buildUrl() {
    return `/${props.item.code.toLowerCase()}/${props.selectedMode.name}?${QueryParams.DualLanguageSignal}`;
}


return { __sfc: true,props, countryHtml, buildUrl }
}

})